import CompDefault from "@/pages/comp_par/main";

const routerArr:object[] = [
  {
    path: "/comp_par",
    element: <CompDefault></CompDefault>,
  },
];

export default routerArr;